export default "Estimez les primes CEE applicables à votre entreprise (bâtiments, équipements, process industriels). Résultat chiffré en 60 secondes avec votre SIRET.";

